import React from 'react';
import { AlertTriangle, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Amber banner shown at the top of the layout when an admin is
 * impersonating a user. Includes the user's email and an end-session button.
 */
export const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, user, logout } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  const handleEndSession = async () => {
    await logout();
    // Close the popup window — reliable since it was opened via window.open
    window.close();
    // Safety fallback: if the browser blocked window.close(), redirect to sign-in
    setTimeout(() => {
      if (!window.closed) {
        navigate('/signin', { replace: true });
      }
    }, 200);
  };

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between text-sm font-medium">
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 flex-shrink-0" />
        <span>
          You are viewing as <strong>{user?.email}</strong> — impersonation session
        </span>
      </div>
      <button
        onClick={handleEndSession}
        className="flex items-center gap-1.5 px-3 py-1 rounded bg-amber-600 hover:bg-amber-700 transition-colors"
      >
        <LogOut className="h-3.5 w-3.5" />
        End session
      </button>
    </div>
  );
};
